<template>
  <div class="profile-body">
    <Goback></Goback>
    <div class="upper-container">
      <div class="profile-image">
        <div class="header-box">
          <div class="bg-img">
            <img :src="getAvatarUrl(userInfo)">
          </div>
          <div class="mask2"></div>
        </div>
        <div class="profile-mask"></div>
        <div class="nickname-container">
          <div class="nickname">{{nickName}}</div>
        </div>
      </div>
      <div class="avatar-info">
        <div class="avatar-container">
          <div class="avatar">
            <img :src="getAvatarUrl(userInfo)"/>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-container">
      <MomentFeedUser :refId="userId" :key="userId"></MomentFeedUser>
    </div>
  </div>
</template>

<script>

  import MomentFeedUser from "../forum/moment/MomentFeedUser";

  import {ActionSheet, Toast} from "vant"
  import UserAvatar from "../common/UserAvatar";
  import ProfileEditBtn from "../common/ProfileEditBtn";
  import Goback from "../common/Goback";

  export default {
    name: "Profile",
    components: {
      Goback,
      ProfileEditBtn,
      UserAvatar,
      MomentFeedUser,
      Toast,
      ActionSheet,
    },
    data() {
      return {
        currentUserId: 0,
        userId: 0,
        userInfo: {},
        actions: [{name: '上传封面'}],
        showActions: false,
        avatarUrlDefault: "http://a1.wanwanshequ.com/static/public/image57e4avatar.png",
      }
    },
    mounted() {
      let userId = this.$route.params.id
      if (userId) {
        this.userId = parseInt(userId)
      }
      this.initCachedUserInfo()
      this.loadUserInfo()
    },

    activated() {
      this.initCachedUserInfo()
      let userId = this.$route.params.id
      if (userId && this.userId !== parseInt(userId)) {
        this.init()
      } else {
        this.loadUserInfo()
      }
      this.showActions = false
    },

    methods: {
      init() {
        this.userInfo = {}
        let userId = this.$route.params.id
        if (userId) {
          this.userId = parseInt(userId)
        }
        this.loadUserInfo()
      },

      getAvatarUrl(user) {
        if (user && user.avatar_url) {
          return user.avatar_url
        } else {
          return ""
        }
      },


      initCachedUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data => {
          this.currentUserId = data.id
        }), () => {
        })
      },

      loadUserInfo() {
        let params = {
          "id": this.userId,
        }
        this.$store.dispatch("UserProfile", params).then((data) => {
          if (data.code === 0) {
            this.userInfo = data.data
          } else {
            Toast("请求错误")
          }
        }, () => {
          Toast("系统错误")
        })
      },
    },
    computed: {
      nickName() {
        if (this.userInfo && this.userInfo.nickname) {
          return this.userInfo.nickname
        } else {
          return ""
        }
      },

      isMine() {
        if (this.currentUserId && this.currentUserId === this.userId) {
          return true
        } else {
          return false
        }
      }
    }

  }

</script>

<style lang="scss" scoped>
  .profile-body {
    background: white;
  }

  .upper-container {
    position: relative;
    height: 290px;
    width: 100%;

    .avatar-info {
      position: absolute;
      right: 20px;
      bottom: 0;

      .avatar-container {
        .avatar {
          font-size: 10px;
          width: 80px;
          height: 80px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 auto;
          overflow: hidden;

          img {
            width: 100%;
          }
        }
      }
    }

    .icon-heart {
      position: absolute;
      right: 20px;
      bottom: 0;
    }
  }

  .edit-profile-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    line-height: 1.5;
    background: rgba(255, 255, 255, 0.95);
    padding: 12px 0;
    color: grey;
    border-top: 1px solid #f2f2f2;
  }

  .profile-mask {
    position: absolute;
    top: 0;
    left: 0;
    height: 20%;
    width: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4), transparent);
  }

  .profile-image {
    width: 100%;
    height: 250px;
    overflow: hidden;
    position: relative;

    .header-box {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 250px;
      overflow: hidden;

      img {
        width: 100%;
        filter: blur(.18rem);
        z-index: 0;
        position: relative;
        margin: 0 auto;
        display: block;
      }

      .mask {
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .3);
        position: absolute;
        top: 0;
        left: 0;
      }

      .mask2 {
        width: 100%;
        height: 80%;
        position: absolute;
        left: 0;
        bottom: 0;
        background: linear-gradient(0deg, rgba(79, 76, 69, 0.82), rgba(255, 255, 255, 0));
      }
    }
  }

  .nickname-container {
    position: absolute;
    right: 120px;
    bottom: 0;
    line-height: 1.5;
    color: white;
    font-size: 20px;
    max-width: 50%;

    .nickname {
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .detail-container {
    margin-top: 12px;

    .cell-title {
      padding: 18px 12px;
      font-weight: bold;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.58);
    }
  }

  .edit-btn-container {
    color: white;
    font-size: 18px;
    font-weight: bold;
    position: absolute;
    right: 20px;
    top: 15px;
  }

</style>
